import { logError } from '@/shared/lib/logging';

/**
 * Converts ISO date string to Unix timestamp (milliseconds since epoch)
 * @param dateString - ISO date string (e.g. "2024-03-25T12:00:00.000Z")
 * @returns Unix timestamp in milliseconds
 * @example
 * ```ts
 * const timestamp = convertDateISOStringToTimestamp("2024-03-25T12:00:00.000Z");
 * console.log(timestamp); // 1711368000000
 * ```
 */
export const convertDateISOStringToTimestamp = (dateString: string): number =>
    Math.floor(new Date(dateString).getTime());

/**
 * Parses a JSON string containing an array of timestamps
 * @param timestamps - JSON string representing an array of timestamps
 * @returns Parsed array of timestamps or null if parsing fails
 * @example
 * ```ts
 * const timestampsArray = parseJsonToArrayOfTimestamps("[1711368000000, 1711371600000]");
 * console.log(timestampsArray); // [1711368000000, 1711371600000]
 * ```
 */
export const parseJsonToArrayOfTimestamps = (
    timestamps: string,
): number[] | null => {
    try {
        return JSON.parse(timestamps);
    } catch (e) {
        logError('Failed to parse timestamps:', e);

        return null;
    }
};
